import { Typography, Box, useTheme } from "@mui/material";
import { tokens } from "../theme";

const Header = ({ title, subtitle, color}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const textColor = color ? color : colors.greenAccent[400];
  return (
    <Box mb="30px">
      <Typography
        variant="h2"
        color={colors.grey[100]}
        fontWeight="bold"
        sx={{ m: "0 0 5px 0" }}
      >
        {title}
      </Typography>
      <Typography variant="h5" color={textColor}>
        {subtitle}
      </Typography>
    </Box>
  );
};

export default Header;
